import { useEffect, useRef } from 'react';

export const useInterval = (callback, delay) => {
  const mounted = useRef(false);
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // eslint-disable-next-line
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      callback();
    }
  });
};

export default useInterval;
